import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'
import { SectionTitle } from './styles'

// Import Components
import { ContentDrawer } from '@jelly/components'

// Styled Components via Emotion
const BuyingGuideWrapper = styled.div`
	p {
		width: 100%;
	}
	h3 {
		${({ theme }) => theme.fonts.header};
		color: ${({ theme }) => theme.colors.teal};
		font-size: 20px;
	}
`

BuyingGuides.propTypes = {
	containers: array.isRequired,
	id: string.isRequired,
	title: string.isRequired,
}
/**
 * Drawers for buying guide sections based on flag in the ccm
 * @param {Array} props.containers :: contains a list of content containers that should display as a buying guide drawer
 * @param {String} props.id :: unique id of the section
 * @param {String} props.title :: title of the section buying guide
 */
export function BuyingGuides({ containers, id, title }) {
	return (
		<BuyingGuideWrapper id={id}>
			<SectionTitle>{title}</SectionTitle>
			{containers.map((buyingGuide, i) => {
				return <ContentDrawer key={i} title={buyingGuide.title} text={buyingGuide.html} />
			})}
		</BuyingGuideWrapper>
	)
}
